"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoPlayReducer = autoPlayReducer;
var _types = require("./types");
var initialState = {
  on: false,
  roundsLeft: 0,
  roundsPlayed: 0,
  showStopButton: false
};
function autoPlayReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.AUTO_PLAY_FREE_SPIN_START:
      {
        return Object.assign({}, state, {
          on: true,
          showStopButton: true
        });
      }
    case _types.AUTO_PLAY_STOP_HIDE:
      {
        return Object.assign({}, state, {
          showStopButton: false
        });
      }
    case _types.AUTO_PLAY_STOP_SHOW:
      {
        return Object.assign({}, state, {
          showStopButton: state.roundsLeft > 0 ? true : false
        });
      }
    case _types.AUTO_PLAY:
      {
        return Object.assign({}, state, {
          showStopButton: true,
          rounds: action.payload,
          roundsLeft: action.payload,
          roundsPlayed: 0,
          on: true
        });
      }
    case _types.AUTO_PLAY_STOP:
      {
        return Object.assign({}, state, {
          showStopButton: false,
          roundsLeft: 0,
          roundsPlayed: 0,
          rounds: 0,
          on: false
        });
      }
    case _types.AUTO_PLAY_ROUND_PLAYED:
      {
        return Object.assign({}, state, {
          roundsLeft: state.roundsLeft - 1,
          roundsPlayed: state.roundsPlayed + 1
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map